export default __webpack_public_path__ + "static/media/filtersBackground.0959cd7a.svg";